module.exports = __webpack_public_path__ + "static/media/track.34649110.svg";